import {tabs} from './DashboardNavigation.types';

const Tab: tabs = {
  portfolio: 'Portfolio',
  transactions: 'Transactions',
};

export {Tab};
